import React, { useEffect, useState } from "react";
import { Control, Controller, FieldErrors, useWatch } from "react-hook-form";
import { FormType } from "./../CreateForm";
import DateInput from "../../global/DateInput";
import ValidateError from "../../global/ValidateError";
import MultipleDate from "../../global/MultipleDate";
import RadioInput from "../../global/RadioInput";
import { useGetAllCourtsByNameQuery } from "../../../lib/redux/services/sections/Courts";
import SearchableSelect from "../../global/SearchableSelect";
import { useSelector } from "react-redux";
import { UserSliceType } from "../../../lib/redux/slices/userSlice";
import { useGetDictionary } from "../../../hooks/useGetDictionary";
import { daysOptions3 } from "../../../data/options";
import SelectOption from "../../global/SelectOption";
import { DictionaryType } from "../../../types";
import Select from "react-select";
import { selectStyle, selectTheme } from "../../../styles/selectStyles";

import Toggle from "../../global/Toggle";
import { useParams } from "react-router-dom";
import { cn, getFormatedDate } from "../../../utils/utils";
import { ExactDurationStepper } from "../../global/Counter";
import Input from "../../global/Input";
import { CircleHelp } from "lucide-react";
import { Tooltip } from "react-tooltip";
type Props = {
  type: "public" | "private";
  control: Control<FormType, any> | any;
  errors: FieldErrors<FormType>;
  getValue: any;
  isAllow: boolean;
  register: any;
  setValue: any;
  selectedCourts: any;
  watch: any;
  trigger: any;
  setAvailableCourtsLoading: any;
  setAvailableCourts: any;
  setSelectedCourts: any;
  setCourts: any;
  data: any;
  eventType: "new" | "edit" | "duplicate" | "view";
};
const slotsOption = [
  { value: 10, label: "10 Min" },
  { value: 15, label: "15 Min" },
  { value: 30, label: "30 Min" },
  { value: 60, label: "60 Min" },
  { value: 90, label: "90 Min" },
  { value: 120, label: "120 Min" },
  { value: 150, label: "150 Min" },
];
function ScheduleInfoV2({
  type,
  control,
  errors,
  register,
  setValue,
  trigger,
  setAvailableCourts,
  setAvailableCourtsLoading,
  getValue,
  setCourts,
  isAllow,
  setSelectedCourts,
  selectedCourts,
  eventType,
  watch,
  data,
}: Props) {
  console.log(isAllow);

  
  const { inputs, events, placeHolders, options }: DictionaryType =
    useGetDictionary();
  const [availableCourtsParam, setAvailableCourtsParam] = useState<any>({});
  const [skipFetch, setSkipFetch] = useState<boolean>(true);
  const param = useParams();
  const selectedClub = useSelector(
    (state: UserSliceType) => state.user.selectedClub
  );
  const startDate = useWatch({ control, name: "start_date" });
  const endDate = useWatch({ control, name: "end_date" });
  const matchDuration = useWatch({ control, name: "match_duration" });
   const getRequiredRounds = () => {
    if (data) {
      const [endHour, endMin] = data.end_time.split(":").map(Number);
      const [startHour, startMin] = data.start_time.split(":").map(Number);

      let startTotal = startHour * 60 + startMin;
      let endTotal = endHour * 60 + endMin;

      // handle crossing midnight
      if (endTotal <= startTotal) {
        endTotal += 24 * 60;
      }

      const totalMinutes = endTotal - startTotal;

      //@ts-ignore
      const matchMinutes = parseInt(watch("match_duration"), 10);
      //@ts-ignore
      const pauseMinutes = parseInt(watch("pause_time"), 10);

      return Math.floor(
        (totalMinutes + pauseMinutes) / (matchMinutes + pauseMinutes)
      );
    }
  };
  return (
    <div className="flex flex-col gap-4 w-full bg-white rounded-2xl p-4 min-h-[350px]">
      <h3 className="font-bold text-[24px] text-primary dark:text-white ">
        Scheduling
      </h3>
      <div className="flex flex-col w-full gap-8">
       
        <div className="flex items-end w-full gap-4 mobile:flex-wrap">
          
          <div className="w-full flex-1  mobile:min-w-[200px]">
              <Tooltip
                id="number_of_courts_required_tooltip"
                style={{
                  backgroundColor: "#f3f3f3",
                  color: "#1e1850",
                  top: "0px",
                  zIndex: 1000,
                }}
                place="top"
              />
              <Controller
                name="required_courts"
                control={control}
                rules={{ required: false }}
                render={({ field }) => (
                  <Input
                    Tooltip={() => (
                      <span className="text-xs inline ">
                        <CircleHelp
                          color="#d1d5db "
                          size={15}
                          className="cursor-context-menu"
                          data-tooltip-id="number_of_courts_required_tooltip"
                          data-tooltip-html={
                            events?.number_of_courts_required_tooltip
                          }
                        />
                      </span>
                    )}
                    label={inputs.number_of_courts_required}
                    inputProps={{
                      ...field,
                      type: "number",
                      onWheel: (e) => {
                        e.preventDefault();
                        //@ts-ignore
                        e.target.blur();
                      },
                      value: Math.ceil(data?.max_number_of_players / 4),

                      readOnly: true,
                      disabled: true,
                    }}
                    customClass="bg-[#F3F3F3]"
                    isRequired={false}
                    labelStyle="whitespace-nowrap"
                  />
                )}
              />
            </div>
           <div className="w-full flex-1 mobile:min-w-[200px]">
              <label className="block text-sm mb-2 text-primary dark:text-white">
                {inputs.maximum_duration_of_round}
                <span className="text-red-500">*</span>
              </label>
              <Controller
                control={control}
                name="match_duration"
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    {...field}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    theme={selectTheme}
                    isDisabled={!isAllow}
                    options={slotsOption}
                    onChange={(selected) =>
                      // @ts-ignore only
                      field.onChange(selected ? selected.value : null)
                    }
                    value={
                      slotsOption.find(
                        (option) => option.value === field.value
                      ) || null
                    }
                  />
                )}
              />
              {errors.match_duration && <ValidateError />}
            </div>
           
         
        
        </div>
        <div className={cn('grid grid-cols-2 gap-[20px]',type === "private" && "grid-cols-3")}>
              
         <div className="w-full flex-1  mobile:min-w-[200px]">
              <Tooltip
                id="number_of_rounds_tooltip"
                style={{
                  backgroundColor: "#f3f3f3",
                  color: "#1e1850",
                  top: "0px",
                  zIndex: 1000,
                }}
                place="top"
              />
              <Input
                Tooltip={() => (
                  <span className="text-xs inline ">
                    <CircleHelp
                      color="#d1d5db "
                      size={15}
                      className="cursor-context-menu"
                      data-tooltip-id="number_of_rounds_tooltip"
                      data-tooltip-html={events?.number_of_rounds_tooltip}
                    />
                  </span>
                )}
                label={inputs.total_number_of_rounds}
                inputProps={{
                  type: "number",
                  onWheel: (e) => {
                    e.preventDefault();
                    //@ts-ignore
                    e.target.blur();
                  },
                  // prettier-ignore

                  value: getRequiredRounds(),
                  readOnly: true,
                  disabled: true,
                }}
                customClass="bg-[#F3F3F3]"
                isRequired={false}
              />
            </div>

            <div className="w-full flex-1 mobile:min-w-[200px]">
              <Controller
                name="number_of_serves"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Input
                    label={inputs.number_of_serves}
                    customClass={`${
                      !isAllow &&
                      eventType == "view" &&
                      "bg-[#f3f3f3] cursor-not-allowed"
                    }`}
                    inputProps={{
                      ...field,
                      type: "number",
                      onWheel: (e) => {
                        e.preventDefault();
                        //@ts-ignore
                        e.target.blur();
                      },

                      placeholder: placeHolders.set_number_of_serves,
                    }}
                  />
                )}
              />
              {errors.number_of_serves &&
                errors.number_of_serves.type === "required" && (
                  <ValidateError />
                )}
            </div>

            
            </div>
        <div className="flex w-full gap-8 justify-between items-center mobile:flex-wrap">
         <p className="text-[14px] text-[#747474]">Availability is computed against your club booking system in real time</p>
          
          <div className=" mobile:pb-2  ">
            <button
              className={cn(
                "flex gap-2 items-center bg-primary dark:bg-primaryYellow dark:text-primary dark:border-none py-4 px-4 rounded-full border border-main-1 text-[#CBDB2A] whitespace-nowrap w-fit text-[16px]",
                (!isAllow || !matchDuration) &&
                  "bg-[#f3f3f3] text-primary dark:text-white cursor-not-allowed"
              )}
              type="button"
              onClick={async (e) => {
                if(!matchDuration) return;
                e.preventDefault();
                if (isAllow || getValue("state") === "Draft") {
                  const checkFieldList = [
                    "start_date",
                    "end_date",
                    "start_time",
                    "end_time",
                    "match_duration",
                  ];
                  // Trigger validation for all fields

                  //@ts-ignore
                  const isValid = await trigger(checkFieldList);

                  // Dispatch action to add league info

                  // Log errors (this will now show the updated errors)

                  // Check if there are no errors
                  if (isValid && Object.keys(errors).length === 0) {
                    console.log(getValue());
                    const available_courts =
                      getValue().available_courts.length >= 0
                        ? getValue().available_courts
                        : Object.keys(getValue().available_courts);
                    setAvailableCourts({
                      ...getValue(),
                      event_id: param.id,
                      court_ids: getValue().court_ids.map(
                        (court: any) => court.id
                      ),
                      club_id: selectedClub,
                      selected_days:[],
                      available_courts:
                        getValue("state") === "Draft"
                          ? []
                          : getValue().available_courts.length >= 0
                          ? getValue().available_courts
                          : Object.keys(getValue().available_courts),
                    });
                    setCourts(getValue().court_ids);
                    setAvailableCourtsLoading(true);
                  }
                }
              }}
            >
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.25 16.25L20.75 20.75" stroke={(!isAllow || !matchDuration)?"#1E1850":"#CBDB2A"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.75 9.75C18.75 4.77944 14.7206 0.75 9.75 0.75C4.77944 0.75 0.75 4.77944 0.75 9.75C0.75 14.7206 4.77944 18.75 9.75 18.75C14.7206 18.75 18.75 14.7206 18.75 9.75Z" stroke={(!isAllow || !matchDuration)?"#1E1850":"#CBDB2A"} stroke-width="1.5" stroke-linejoin="round"/>
</svg>

              Check courts availability
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleInfoV2;
